import React, { useContext, useEffect, useRef } from 'react'
import axios from 'axios'
import ENDPOINT from '../../context/EndPoint'
import SecurityHeaders from '../../context/SecurityHeaders'
import { useState } from 'react'

import { Delete } from '@material-ui/icons';
import DeleteModal from '../../components/modals/DeleteModal'
import { AuthContext } from '../../context/AuthContext'
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useDispatch } from 'react-redux'

const ReviewVideoItem = ({ image, reload, index }) => {
    const dispatch = useDispatch()
    const { user } = useContext(AuthContext);
    const [open, setOpen] = useState(false)
    const videoRefs = useRef([]);
    const mainVideoRef = useRef(null);
    const [deleteid, setdeleteid] = useState(null);
    const [toast, setToast] = useState({
        open: false,
        message: '',
        type: ''

    });
    useEffect(() => {

        const handlePlayPause = (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    mainVideoRef.current.play();
                } else {
                    mainVideoRef.current.pause();
                }
            });
        };

        const observer = new IntersectionObserver(handlePlayPause, {
            threshold: 0.5, // Adjust this value as needed
        });

        if (mainVideoRef.current) {
            observer.observe(mainVideoRef.current);
        }

        return () => {
            if (mainVideoRef.current) {
                observer.unobserve(mainVideoRef.current);
            }
        };
    }, []);

    const handleMouseEnter = (index) => {
        videoRefs.current[index].play();
        videoRefs.current[index].controls = true;
        pauseOtherVideos(index);
    };

    const handleMouseLeave = (index) => {
        videoRefs.current[index].pause();
        videoRefs.current[index].controls = false;
    };

    const handleVideoClick = (index) => {
        if (!videoRefs.current[index].paused) {
            videoRefs.current[index].pause();
        } else {
            videoRefs.current[index].play();
            pauseOtherVideos(index);
        }
    };

    const pauseOtherVideos = (currentIndex) => {
        videoRefs.current.forEach((video, index) => {
            if (index !== currentIndex) {
                video.pause();
                video.controls = false;
            }
        });
    };

    const deleteImage = async ({ id }) => {
        dispatch({ type: 'LOADING' })
        try {
            const data = new FormData();
            data.append('id', id);
            data.append('session', user.SessionId);
            const response = await axios.post(`${ENDPOINT}review-video-delete.php`, data, SecurityHeaders)
            if (response.data.status === 'success') {
                dispatch({ type: 'DONE_LOADING' })

                setToast({ open: true, message: 'Video deleted successfully!', type: 'success' });
                setOpen(false);
                reload()
            }
        } catch (error) {

            dispatch({ type: 'ERROR', payload: error.message })
        }
    }
    const handleClose2 = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setToast(open => ({ ...open, open: false }));
    };
    return (


        <>
            <DeleteModal show={open} HandleDelete={() => deleteImage({ id: deleteid })} HandleClose={() => setOpen(false)} />

            <Snackbar open={toast.open} onClose={handleClose2} autoHideDuration={4000} >
                <Alert

                    severity={toast.type === 'success' ? 'success' : 'error'}
                    onClose={() => { }}
                    variant="filled"
                    className='col-md-6 col-12'

                >
                    {toast.message}
                </Alert>
            </Snackbar>


            <tr key={image.id}>


                <td className='col-2'>


                    <img className="image img-fluid" src={image.cover_photo} alt={image.category} />



                </td>
                <td><div className="col-lg-3">

                    <video
                        ref={(el) => (videoRefs.current[index] = el)}
                        className='w-100 rounded border bg-dark'
                        poster={image.cover_photo}
                        onMouseEnter={() => handleMouseEnter(index)}
                        onMouseLeave={() => handleMouseLeave(index)}
                        onClick={() => handleVideoClick(index)}
                    >
                        <source src={image.video_url} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>



                </div></td>
                <td>{image.category}</td>

                <td><Delete type="button" className='text-danger' onClick={() => { setdeleteid(image.id); setOpen(true) }} /></td>
            </tr>

        </>

    )
}

export default ReviewVideoItem
